import { Injectable } from "@angular/core";
import { EMPTY, Observable, Subject } from "rxjs";
import { GeoInfoInterface } from "../../models";
import { gpsLocationSmoother, location_service } from "./gps-location-smoother";

// Placeholder so consumers that type Location from @capgo/background-geolocation compile.
export type Location = location_service & { time: number };

// Browser PPOS/home: LOMR Fresach heliport, from OFMX navdata.
const DEFAULT_GEO: GeoInfoInterface = {
  longitude: 13.664803,
  latitude: 46.741016,
  heading: 0,
  speed: 0,
  altitude: 2850 * 0.3048,
  accuracy: 1,
  altitudeAccuracy: 1,
  timestamp: 0,
  valid: false,
  type: 1,
  internal: true,
};

/**
 * Browser-only GeolocationService. File-replaces the native version under the
 * `browser` Angular build configuration. GPS is unavailable in the browser —
 * all methods are no-ops and observables never emit.
 */
@Injectable({ providedIn: "root" })
export class GeolocationService {
  public geoLocSmoother: gpsLocationSmoother = new gpsLocationSmoother();
  public geoInfo: GeoInfoInterface = { ...DEFAULT_GEO, timestamp: Date.now() };
  public simRequestPending = false;
  public gpsDisabled = false;

  public _geo_info_updates = new Subject<GeoInfoInterface>();
  public readonly location$: Observable<Location> = EMPTY as Observable<Location>;
  public readonly geolocation$: Observable<GeoInfoInterface> = this._geo_info_updates.asObservable();

  async startLocationUpdates(): Promise<void> {}
  async fetchSimulatorGeoLocation(): Promise<GeoInfoInterface> {
    return this.geoInfo;
  }
  async sendGeo(_location: any, _valid: boolean): Promise<void> {}
  getGeoInfo(): GeoInfoInterface {
    return this.geoInfo;
  }
  async stopLocationUpdates(): Promise<void> {}
  async startXPlaneLocationUpdates(): Promise<void> {}
  async stopXPlaneLocation(): Promise<void> {}
  async experimentalSimulatorPosition(_param: string): Promise<number> {
    return 0;
  }
}
